
const setPickupList = (state, pickupList) => {
  state.pickupList = pickupList;
};



export default {
  setPickupList,
};



// WEBPACK FOOTER //
// ./src/store/modules/pickup/mutations.js